import { type TimerData } from './types'

const STORAGE_KEY = 'AuroraTheme-Timer'

export class TimerStorage {
  private readonly _blockId: string

  constructor(blockId: string) {
    this._blockId = blockId
  }

  private parseData(data: string | null): TimerData | null {
    try {
      const obj = JSON.parse(data ?? '{}')

      if ('endDate' in obj && 'hash' in obj) {
        return {
          endDate: new Date(+obj.endDate),
          hash: obj.hash,
        }
      }

      return null
    } catch (error) {
      return null
    }
  }

  public saveData(data: TimerData): void {
    try {
      localStorage.setItem(
        `${STORAGE_KEY}-${this._blockId}`,
        JSON.stringify({ endDate: data.endDate.getTime(), hash: data.hash }),
      )
    } catch (e) {}
  }

  public loadData(): TimerData | null {
    try {
      return this.parseData(
        localStorage.getItem(`${STORAGE_KEY}-${this._blockId}`),
      )
    } catch (e) {
      return null
    }
  }
}
